import React from 'react';
import { useSelector } from 'react-redux';
import Image from '../Image/image-component';
import SystemDataService from '../../Services/SystemDataService';

export default function OurApproachSection({ sectionData }) {
    const { links } = useSelector((state) => state.systemData || {});
    const logo = SystemDataService.byLabel(links, 'Logo');

    const { label, title, paragraphs = [], quote } = sectionData || {};

    return (
        <section className="w-full bg-white py-16 md:py-20 lg:py-28 px-5 md:px-6 overflow-hidden">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">

                {/* Logo */}
                <div className="w-full flex justify-center lg:justify-start">
                    <div className="w-full max-w-[200px] md:max-w-[420px] lg:max-w-[400px] transition-transform duration-700 hover:scale-105">
                        <Image
                            src={logo?.image}
                            alt="BH Hardware Logo"
                            className="w-full h-auto object-contain"
                            useSekeleton={false}
                        />
                    </div>
                </div>

                {/* Content */}
                <div className="w-full max-w-3xl text-left">
                    {label && (
                        <span className="inline-block text-secondary-500 font-bold uppercase tracking-wide text-base md:text-lg border-b-2 border-secondary-500 pb-1 mb-7">
                            {label}
                        </span>
                    )}

                    {title && (
                        <h2 className="text-3xl md:text-5xl lg:text-5xl font-bold text-primary-950 leading-[1.08] mb-6">
                            {title}
                        </h2>
                    )}

                    {paragraphs.length > 0 && (
                        <div className="space-y-1 text-lg md:text-xl lg:text-xl text-primary-950 leading-relaxed mb-7">
                            {paragraphs.map((p, i) => (
                                <p key={i}>
                                    {p.text}
                                    {p.bold && (
                                        <strong className="font-bold">
                                            {p.bold}
                                        </strong>
                                    )}
                                </p>
                            ))}
                        </div>
                    )}

                    {quote && (
                        <div className="border-l-[5px] border-secondary-500 pl-5 py-1">
                            <p className="text-lg md:text-xl font-bold text-primary-950 leading-relaxed">
                                {quote}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}